/* eslint-disable default-param-last */
/**
 * @deprecated Prefer use createPictureFactory from @funtech-int/yango-shared
 */
export function getImageUrlBySize(originalUrl = '', size: string, removeScheme = true): string {
    const isResizable = /\/orig$/.test(originalUrl);
    const result = isResizable ? originalUrl.replace('orig', size) : originalUrl;

    return removeScheme ? removeImageUrlProtocol(result) : result;
}

/**
 * @deprecated Prefer use createPictureFactory from @funtech-int/yango-shared
 */
export const getAvatarsImageUrl = (baseUrl: string = '', size: string) => {
    if (!baseUrl) {
        return '';
    }

    return `${baseUrl}/${size}`;
};

/**
 * @deprecated Prefer use createPictureFactory from @funtech-int/yango-shared
 */
function removeImageUrlProtocol(imageUrl: string): string {
    return imageUrl.replace(/^.*?:\/\//, '//');
}

interface Image {
    avatarsUrl: string | null;
    fallbackUrl: string | null;
}

export function transformImage(image?: Partial<Image> | null): string | undefined {
    const url = image?.avatarsUrl ?? image?.fallbackUrl;
    return url ? `${url}/orig` : undefined;
}
